import React from 'react';
import { Checkbox, Form, Header, Message, Segment } from 'semantic-ui-react';

interface Props {
    aprobacion: {
        estado: 'aprobado' | 'rechazado' | 'sin-supervision';
        motivo: string;
    };
    verificacion: {
        tieneFotocopias: boolean;
        tieneHuellas: boolean;
        tieneFirmas: boolean;
        estado: 'pendiente' | 'verificada';
    };
}

// TODO: Analizar estos componentes. Se encuentran también en supervisión y son iguales. Ver si se
// pueden dejar en un lugar común

type EstadosSupervision = 'aprobado' | 'rechazado' | 'sin-supervision';

const nombresEstadosDeAprobacion: Record<EstadosSupervision, string> = {
    'aprobado': 'Aprobada',
    'rechazado': 'Rechazada',
    'sin-supervision': 'Sin supervisión',
};

const PanelEstadoDeSupervision: React.FunctionComponent<Props> = props => {
    const { aprobacion, verificacion } = props;
    return (
        <div>
            <Segment>
                <Header as='h2' content='Estado de supervisión' />
                {panelEstadoDeAprobacion(aprobacion)}
                {panelEstadoDeVerificacion(verificacion)}
            </Segment>
        </div>
    );
};

function panelEstadoDeVerificacion(verificacion: {
    tieneFotocopias: boolean;
    tieneHuellas: boolean;
    tieneFirmas: boolean;
    estado: 'pendiente' | 'verificada';
}) {
    return (
        <Segment>
            <Form>
                <Message
                    negative={verificacion.estado === 'pendiente'}
                    positive={verificacion.estado === 'verificada'}
                >
                    <Form.Field>
                        <Checkbox
                            label='Fotocopias generadas'
                            name='grupoVerificacion'
                            checked={verificacion.tieneFotocopias}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Checkbox
                            label='Huellas digitales son iguales'
                            name='grupoVerificacion'
                            checked={verificacion.tieneHuellas}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Checkbox
                            label='Tiene firmas'
                            name='grupoVerificacion'
                            checked={verificacion.tieneFirmas}
                        />
                    </Form.Field>
                </Message>
            </Form>
        </Segment>
    );
}

function panelEstadoDeAprobacion(aprobacion: {
    estado: 'aprobado' | 'rechazado' | 'sin-supervision';
    motivo: string;
}) {
    return (
        <Segment raised>
            <Message
                positive={aprobacion.estado === 'aprobado'}
                negative={aprobacion.estado === 'rechazado'}
                warning={aprobacion.estado === 'sin-supervision'}
            >
                <Message.Header>{nombresEstadosDeAprobacion[aprobacion.estado]}</Message.Header>

                <Message.Content>
                    {aprobacion.estado === 'rechazado' && (
                        <p style={{ whiteSpace: 'pre-line' }}>{aprobacion.motivo}</p>
                    )}
                </Message.Content>
            </Message>
        </Segment>
    );
}

export default PanelEstadoDeSupervision;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/MisMatriculas/ProcesoDeMatricula/PanelEstadoDeSupervision.tsx